import { Box, Button, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const DecorativeShape = ({
  src,
  position,
}: {
  src: string;
  position: "top" | "bottom";
}) => (
  <Box
    component="img"
    src={src}
    alt={`Forma ${position}`}
    sx={{
      position: "absolute",
      [position]: 0,
      left: 0,
      width: "100%",
      height: 200,
      zIndex: 1,
      display: { xs: "none", sm: "none", md: "block" },
    }}
  />
);

const Title = ({ children }: { children: React.ReactNode }) => (
  <Typography
    variant="h5"
    sx={{
      mb: 1,
      fontWeight: "bold",
      fontFamily: "Montserrat",
      color: "#234C61",
      fontSize: { xs: 14, sm: 20, md: 30 },
    }}
  >
    {children}
  </Typography>
);

const BodyText = ({ children }: { children: React.ReactNode }) => (
  <Typography
    sx={{
      mb: 1,
      fontFamily: "Montserrat",
      color: "#234C61",
      fontSize: { xs: 11, sm: 18, md: 22 },
    }}
  >
    {children}
  </Typography>
);

const ActionButton = ({ url }: { url: string }) => (
  <Button
    variant="contained"
    startIcon={<InfoOutlinedIcon />}
    onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
    sx={{
      backgroundColor: "#234C61",
      color: "#ffffff",
      fontWeight: "bold",
      textTransform: "uppercase",
      fontFamily: "Montserrat",
      borderRadius: "50px",
      padding: "8px 16px",
      fontSize: "0.85rem",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#336B87",
        boxShadow: "none",
      },
    }}
  >
    ¿Cómo actualizar mi contraseña?
  </Button>
);

export { ActionButton, DecorativeShape, Title, BodyText };
